var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5716 6.8756L3.00379 1.02321C2.80314 0.900892 2.57363 0.833998 2.33868 0.82936C2.10373 0.824722 1.87175 0.882506 1.66643 0.996813C1.46111 1.11112 1.2898 1.27786 1.16997 1.48001C1.05015 1.68216 0.986101 1.91248 0.984375 2.14747V13.8522C0.986101 14.0872 1.05015 14.3175 1.16997 14.5197C1.2898 14.7218 1.46111 14.8886 1.66643 15.0029C1.87175 15.1172 2.10373 15.175 2.33868 15.1703C2.57363 15.1657 2.80314 15.0988 3.00379 14.9765L12.5716 9.12411C12.7645 9.00667 12.924 8.84156 13.0346 8.64467C13.1453 8.44777 13.2034 8.22571 13.2034 7.99985C13.2034 7.77399 13.1453 7.55194 13.0346 7.35504C12.924 7.15814 12.7645 6.99303 12.5716 6.8756ZM2.57812 13.3688V2.63091L11.3544 7.99985L2.57812 13.3688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3e595d0d3ee788a8efbce917f84cf8e8.svg";
export { ForwardRef as ReactComponent };